import React, { useEffect, useState } from 'react';
import { load } from '@cashfreepayments/cashfree-js';
import Loader from 'shared/common/loader';

function CashfreeLoad() {
  const [loading, setloading] = useState(false);
  const cashfree = async (subId) => {
    const res = await load({
      mode: 'sandbox',
    });
    res
      .subscriptionsCheckout({
        subsSessionId: subId,
        redirectTarget: '_self',
      })
      .then(function (result) {
        setloading(false);

        if (result.error) {
         console.log(result.error,'2')
        }
      });
  };
  useEffect(() => {
    setloading(true);
    const subscriptionId = localStorage.getItem('subscriptionId');
    cashfree(subscriptionId);
    localStorage.removeItem('subscriptionId');
  }, []);

  return <>{loading && <Loader />}</>;
}

export default CashfreeLoad;
